export default {
  businessToolkit: [
    {
      partner_name: `Business Toolkit`,
      link_destination: `https://www2.twine.net/ManageJobsBusinessToolkit`,
      desktop_image: `BizToolkitDesktop.webp`,
      mobile_image: `BizToolkitMobile.webp`,
      alt: `business-toolkit`,
    },
  ],
};

// eslint-disable-next-line no-unused-vars
const advertObjectTemplate = [
  {
    name: ``,
    url: ``,
    desktopImage: ``,
    mobileImage: ``,
    alt: ``,
  },
];
